import { Link } from 'react-router-dom'
import usePollingFetch from '../../hooks/usePollingFetch'
import React from 'react'

export default function RecentCertificates() {
  // Chama o hook de polling a cada 2 minutos
  const rawData = usePollingFetch('https://gallery-proxy-service-236688625650.southamerica-east1.run.app', 2 * 60 * 1000)

  // Mapeia e pega os 3 mais recentes
  const certs = rawData
    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
    .slice(0, 3)
    .map(item => {
      return {
      tokenId:     item.ipfs_hash,
      imageUrl:    item.pinata_url,
      title:       item.file_name,
      description: item.description || item.file_name,
      transaction:    item.transaction_hash,
      transactionUrl: item.transaction_url,
      date: new Date(item.timestamp).toLocaleDateString('pt-BR'),
    }})

  if (certs.length === 0) {
    return <p className="text-center">Nenhum certificado recente.</p>
  }

  return (
    <section className="mt-5">
      <div className="d-flex align-items-center justify-content-between mb-6">
        <h2>Certificados recentes</h2>
        <Link to="/gallery" className="text-primary">
          Ver todos
        </Link>
      </div>
        <div className="row g-4">
          {certs.map(cert => (
            <div key={cert.tokenId} className="col-12 col-sm-6 col-lg-4">
              {/*
              <Link
                to={`/certificates/${cert.tokenId}`}
                state={{ cert }}
                className="card h-100 text-decoration-none shadow-sm transition"
                style={{ borderRadius: '1rem', overflow: 'hidden' }}
              >
              </Link>
              */}
                <img
                  src={cert.imageUrl}
                  alt={cert.title}
                  className="card-img-top"
                  style={{ objectFit: 'cover', height: '12rem' }}
                />
                <div className="card-body">
                  <h5 className="card-title text-dark">{cert.title}</h5>
                  <div className='d-flex justify-content-between align-items-center'>
                    <p className="card-text text-muted">{cert.description}</p>
                    <div className='d-flex flex-column'>
                      <a href={cert.transaction.startsWith('0x') ?
                        `https://sepolia.etherscan.io/tx/${cert.transaction}` :
                        `https://sepolia.etherscan.io/tx/0x${cert.transaction}`}
                        target='_black'
                      >
                        Sepolia
                      </a>
                      <a href={`${cert.imageUrl}`}
                        target='_black'
                      >
                        Pinata
                      </a>
                    </div>
                  </div>
                  <div className="d-flex flex-column justify-content-between align-items-center mt-3">
                    <span style={{color: 'white'}} className="badge bg-success">NFT #{cert.tokenId}</span>
                    <small className="text-secondary">{cert.date}</small>
                  </div>
                </div>
            </div>
          ))}
        </div>
    </section>
  )
}
